import {ColorTile, Text, getHexFromColorCode} from '@smart/web-components';
import React from 'react';
import type {DisclaimerRefs} from '../../../bff/app-model/create-app-model';
import type {Highlight as HighlightType} from '../../../bff/product-search-model/create-product-search-model';
import {Highlight} from '../highlight';
import styles from '../product-card/index.module.scss';

interface HighlightListProps {
  id: string;
  exteriorLabel?: string;
  interiorLabel?: string;
  listItems: HighlightType[];
  disclaimerRefs?: DisclaimerRefs;
}

const isColor = (colorId: string): boolean =>
  colorId === `exteriorColor` || colorId === `interiorColor` ? true : false;

export const HighlightList: React.FC<HighlightListProps> = ({
  id,
  listItems,
  exteriorLabel,
  interiorLabel,
  disclaimerRefs,
}) => {
  const notColorItems = listItems.filter((item) => !isColor(item.id));
  const colorItems = listItems.filter((item) => isColor(item.id));

  return (
    <div>
      <ul className={styles.productCardHighlights}>
        {notColorItems.map((item) => (
          <li key={`product-card-${id}-highlight-${item.id}`}>
            <Highlight
              text={item.text}
              disclaimerRef={disclaimerRefs?.[item.id as keyof DisclaimerRefs]}
            />
          </li>
        ))}
      </ul>
      <ul className={styles.productTilesContainer}>
        {colorItems.map((item) => (
          <li
            key={`product-card-${id}-highlight-${item.id}`}
            className={styles.colorItem}
          >
            {item.colorCode && (
              <ColorTile
                id={item.id}
                primaryColor={getHexFromColorCode(item.colorCode!)}
                secondaryColor={getHexFromColorCode(item.roofColorCode, ``)}
                titleText={item.text}
              />
            )}
            <Text tag="span">
              {item.id === `exteriorColor`
                ? `${exteriorLabel?.replace(`:`, ``)}: ${item.text}`
                : `${interiorLabel?.replace(`:`, ``)}: ${item.text}`}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  );
};
